import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetailPosComponent } from './detail-pos.component';

const routes: Routes = [{ path: ':id', component: DetailPosComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DetailPosRoutingModule {}
